var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1766_2729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5864 19.8621H0.414116C0.185601 19.8621 0.000305176 19.6768 0.000305176 19.4482V4.55175C0.000305176 4.32324 0.185601 4.13794 0.414116 4.13794H23.5864C23.815 4.13794 24.0003 4.32324 24.0003 4.55175V19.4482C24.0002 19.6768 23.8149 19.8621 23.5864 19.8621Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.414368 4.20532H2.24542L9.89386 9.21704L9.99835 9.2854V4.20532H14.0023V9.2854L14.1058 9.21704L21.7552 4.20532H23.5862C23.7775 4.20532 23.9329 4.3607 23.9329 4.552V5.58521L17.386 9.87427L17.1976 9.99829H23.9329V14.0012H17.1976L17.386 14.1252L23.9329 18.4143V19.4485C23.9328 19.6397 23.7775 19.7942 23.5862 19.7942H21.7542L14.1058 14.7834L14.0023 14.7151V19.7942H9.99835V14.7151L9.89484 14.7834L2.2464 19.7942H0.414368C0.223153 19.7942 0.0678215 19.6397 0.067688 19.4485V18.4143L6.61456 14.1252L6.80304 14.0012H0.067688V9.99829H6.80304L6.61456 9.87427L0.067688 5.58521V4.552C0.067688 4.3607 0.22307 4.20532 0.414368 4.20532Z",
    stroke: "white",
    strokeWidth: 0.134776
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 10.7586H13.2416V4.13794H10.7589V10.7586H0.000305176V13.2414H10.7589V19.8621H13.2416V13.2414H24.0002V10.7586Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38858 14.0691L0.012146 19.5064C0.0414428 19.7063 0.206208 19.8622 0.414191 19.8622H0.984142L9.90864 14.0691H8.38858V14.0691V14.0691Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2375 14.0691H14.7174L23.6289 19.8536C23.8366 19.8315 24.0005 19.6619 24.0005 19.4484V19.1081L16.2375 14.0691Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000610352 5.00847L7.58397 9.93098H9.10403L0.241688 4.17822C0.100126 4.24399 0.000610352 4.38532 0.000610352 4.55167V5.00847Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5896 9.93101L23.9862 4.48055C23.9513 4.28733 23.7901 4.13794 23.5868 4.13794H22.9939L14.0696 9.93101H15.5896Z",
    fill: "#FF4B55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1766_2729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.a636c30c6f7c7f6415ebaa78e81647b5.svg";
export { ForwardRef as ReactComponent };